import { userTypePageAcl } from '@/router/consts'
import { dashboardRouterNames } from '@/utils/consts'

const NotFound = () => import('@/pages/NotFound')
const PublicLogin = () => import('@/pages/PublicLogin')
const AuthenticationCode = () => import('@/pages/AuthenticationCode')
const ForgotPwd = () => import('@/pages/settings/ForgotPwd')
const ResetPwd = () => import('@/pages/settings/ResetPwd')
const userGuideAndFormsDisplay = () => import('@/modules/userGuideAndFormsDisplay')
const UnlockAccount = () => import('@/pages/UnlockAccount')
const ConfirmUnlock = () => import('@/pages/ConfirmUnlock')

const prefix = ''
const userTypeAcl = userTypePageAcl.common

const paths = {
  routes: [
    /**
     * Ext common view
     */
    { path: '/pub/login', name: dashboardRouterNames.publicLogin, component: PublicLogin },
    { path: '/pub/authentication-code', name: 'authenticationCode', component: AuthenticationCode },
    { path: '/pub/forgot', name: 'forgotPwd', component: ForgotPwd },
    { path: '/pub/resetpwd', name: 'resetPwd', component: ResetPwd, meta: { userTypeAcl: () => true } },
    { path: '/pub/reset', name: 'resetContractorPwd', component: ResetPwd },
    { path: '/user-guide-forms', name: 'userGuideForms', component: userGuideAndFormsDisplay },
    { path: '/pub/unlock', name: 'unlockAccount', component: UnlockAccount },
    { path: '/pub/confirm-unlock', name: 'confirmUnlock', component: ConfirmUnlock },
    /**
     * page not found
     */
    { path: '/404', name: 'notFound', component: NotFound, meta: { showHeaderFooter: false } },
    { path: '/*', redirect: '/404' },
  ],
}

export default { prefix, paths, userTypeAcl }
